import { Button, CircularProgress } from "@material-ui/core";
import React, { useState } from "react";
import { IconWithTooltip } from "../icons/IconWithTooltip";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import axios from "axios";

export function CustomsSync({ syncInvoices }) {
  const { refresh, mode } = syncInvoices;
  const syncInvoicesPath = "api/customs/invoice";
  const [loading, setLoading] = useState(false);
  const handleSync = async () => {
    setLoading(true);
    try {
      const requestObject = {
        mode: mode,
      };
      await axios.post(syncInvoicesPath, requestObject);
    } catch (error) {
      console.error("Error during API sync:", error);
    } finally {
      setLoading(false);
      refresh();
    }
  };

  return (
    <IconWithTooltip title="Számlák letöltése">
      <Button className="material-action-icon-button" onClick={handleSync}>
        {loading ? (
          <CircularProgress size={22} color="inherit" />
        ) : (
          <CloudDownloadIcon className="material-action-icon" />
        )}
      </Button>
    </IconWithTooltip>
  );
}
